import React from 'react';
import { productVolume, priceInfo, promoTimeLeft } from '../productMeta';

const ProductModal = ({ product, onClose, addToCart }) => {
    if (!product) return null;
    const volume = productVolume(product);
    const pi = priceInfo(product);
    const hasDiscount = pi.discount_amount > 0;

    return (
        <div className="product-modal-overlay" onClick={onClose}>
            <div className="product-modal" onClick={(e) => e.stopPropagation()}>
                <img
                    src={product.photo}
                    alt={product.name}
                    className="w-full h-64 sm:h-80 object-cover bg-[#F5F0EB] rounded-t-3xl"
                />
                <div className="p-8">
                    <h2 className="serif text-3xl">{product.name}</h2>
                    <p className="text-sm text-gray-500 mt-1">
                        {product.category}{volume ? ` · ${volume}` : ''}
                    </p>

                    {hasDiscount ? (
                        <div className="mt-2">
                            <div className="flex items-baseline gap-3 flex-wrap">
                                <span className="text-2xl font-bold text-red-600">
                                    {Math.round(pi.final_price)} ₽
                                </span>
                                <span className="text-base text-gray-400 line-through">
                                    {Math.round(pi.base_price)} ₽
                                </span>
                                {pi.badge && (
                                    <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                                        {pi.badge}
                                    </span>
                                )}
                            </div>
                            <p className="text-xs text-[#6B7A6A] mt-1">
                                Вы экономите {Math.round(pi.discount_amount)} ₽
                                {pi.ends_at && <> · {promoTimeLeft(pi.ends_at)}</>}
                            </p>
                        </div>
                    ) : (
                        <p className="text-2xl font-bold text-[#1C1917] mt-2">{Math.round(pi.base_price)} ₽</p>
                    )}

                    <p className="text-gray-600 mt-4 leading-relaxed">{product.description}</p>
                    <div className="mt-6 flex gap-4">
                        <button onClick={() => { addToCart(product); onClose(); }} className="btn-primary flex-1">
                            Добавить в корзину
                        </button>
                        <button onClick={onClose} className="btn-outline">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductModal;